import { ChatkeeperIntegrationRequest } from "../IntegrationRequest/ChatkeeperIntegrationRequest";
import { ChatkeeperRequestTypeEnum } from "../types";

export class RunTriggerRequest extends ChatkeeperIntegrationRequest {
  type: ChatkeeperRequestTypeEnum = ChatkeeperRequestTypeEnum.RunTrigger;

  trigger_id!: number
}